<template>
	<svg
		v-if="isRaw"
		class="app-icon"
		:width="size"
		:height="size"
		:viewBox="viewBox"
		fill="currentColor"
		aria-hidden="true"
		v-html="body"
	/>
	<svg
		v-else
		class="app-icon"
		:width="size"
		:height="size"
		:viewBox="viewBox"
		fill="none"
		stroke="currentColor"
		:stroke-width="strokeWidth"
		stroke-linecap="round"
		stroke-linejoin="round"
		aria-hidden="true"
		v-html="body"
	/>
</template>

<script setup lang="ts">
import { computed } from "vue"
import { IconName, iconBody, iconIsRaw, iconViewBox } from "@/components/icons/registry"

const props = withDefaults(
	defineProps<{
		name: IconName
		size?: number | string
		strokeWidth?: number | string
	}>(),
	{
		size: 20,
		strokeWidth: 1.5,
	}
)

const body = computed(() => iconBody(props.name))
const viewBox = computed(() => iconViewBox(props.name))
const isRaw = computed(() => iconIsRaw(props.name))
</script>

<style scoped>
.app-icon {
	flex-shrink: 0;
}
</style>
